import { ESpecialPackageStatus } from "@base/enums";
import { ISpecialPackage } from "./patientSpecialPackage.interface";

/** What needs the patient's attention first, down to what is already over. */
const STATUS_ORDER: string[] = [
  ESpecialPackageStatus.UNPAID,
  ESpecialPackageStatus.PENDING,
  ESpecialPackageStatus.IN_PROGRESS,
  ESpecialPackageStatus.COMPLETED,
  ESpecialPackageStatus.CANCELLED,
];

/**
 * The server returns packages in its own order, so the list is sorted client-side: by status first,
 * then by `display_priority` descending. An unknown status sorts last rather than first.
 */
export const sortSpecialPackages = (packages: ISpecialPackage[]) => {
  return [...packages].sort((a, b) => {
    const rankA = STATUS_ORDER.indexOf(String(a.status));
    const rankB = STATUS_ORDER.indexOf(String(b.status));
    const orderA = rankA < 0 ? STATUS_ORDER.length : rankA;
    const orderB = rankB < 0 ? STATUS_ORDER.length : rankB;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    return (b.display_priority ?? 0) - (a.display_priority ?? 0);
  });
};
